<ng-container *ngIf="state$ | async as state">
  <div
    *ngIf="state.active && !overlayDismissed"
    class="auth-brand-intro"
    [style.--intro-duration.ms]="state.duration"
    [class.auth-brand-intro--fade-out]="overlayShouldFade"
    (animationend)="handleOverlayFadeOutEnd($event)"
  >
    <div class="auth-brand-intro__backdrop"></div>

    <div class="auth-brand-intro__glow auth-brand-intro__glow--primary"></div>
    <div class="auth-brand-intro__glow auth-brand-intro__glow--secondary"></div>

    <div class="auth-brand-intro__content">
      <div
        class="auth-brand-intro__logo-shell"
        [class.auth-brand-intro__logo-shell--drop]="logoShouldDrop"
        [class.auth-brand-intro__logo-shell--scale]="logoShouldScaleUp"
        (animationend)="handleLogoDropAnimationEnd($event)"
      >
        <img
          class="auth-brand-intro__logo"
          width="140"
          height="48"
          src="/assets/image/prisma-logo-light.png"
          alt="smzh prisma"
          loading="lazy"
        />
      </div>

      <p
        *ngIf="showIntroTagline"
        class="auth-brand-intro__tagline"
        (animationend)="handleIntroTaglineAnimationEnd()"
      >
        Ihre Finanzberatung der Zukunft.
      </p>

      <p
        *ngIf="showGreeting"
        class="auth-brand-intro__tagline auth-brand-intro__tagline--greeting"
        (animationend)="handleGreetingAnimationEnd($event)"
      >
        <ng-container *ngIf="(userFirstName$ | async) as firstName; else fallbackGreeting">
          Willkommen im smzh prisma,
          <span class="auth-brand-intro__tagline-highlight">
            {{ firstName }}
          </span>
          <span aria-hidden="true" class="auth-brand-intro__wave">👋</span>
        </ng-container>

        <ng-template #fallbackGreeting>
          Willkommen im smzh prisma
          <span aria-hidden="true" class="auth-brand-intro__wave">👋</span>
        </ng-template>
      </p>
    </div>
  </div>
</ng-container>
